import { type PropsWithChildren } from 'preact/compat';

import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};
